import { useEffect, useRef } from 'react'
import { useRouteContext } from '@tanstack/react-router'
import { SidebarModule } from '@/config/permissions'
import { useChatStore, selectSetQueryClient } from '@/stores/chat.store'
import { useModuleAccess } from '@/hooks/use-module-access'
import { useSidebar } from '@/components/ui/sidebar'
import { Main } from '@/components/layout/main'
import { ChatsDialogs } from './components/chat-dialogs'
import { ChatMain } from './components/chat-main'
import { ChatSidebar } from './components/chat-sidebar'

export default function Chats() {
  useModuleAccess(SidebarModule.CHAT)
  const { open, setOpen } = useSidebar()
  const { queryClient } = useRouteContext({ from: '/_authenticated' })
  const currentTicketId = useChatStore((state) => state.currentTicketId)
  const setQueryClient = useChatStore(selectSetQueryClient)
  const sidebarClosedFirstRender = useRef(false)

  useEffect(() => {
    if (open && !sidebarClosedFirstRender.current) {
      setOpen(false)
    }
    sidebarClosedFirstRender.current = true
  }, [open, setOpen])

  useEffect(() => {
    setQueryClient(queryClient)
  }, [queryClient, setQueryClient])

  return (
    <Main fixed>
      <section className='flex h-full gap-3 sm:gap-6'>
        <div
          className={
            currentTicketId ? 'hidden sm:flex' : 'flex w-full sm:w-auto'
          }
        >
          <ChatSidebar />
        </div>
        <div
          className={
            currentTicketId ? 'flex w-full' : 'hidden sm:flex sm:flex-1'
          }
        >
          <ChatMain />
        </div>
      </section>
      <ChatsDialogs />
    </Main>
  )
}
